import { micromodal } from "micromodal";

export function drawer() {
  MicroModal.init();

  const buttons = document.querySelectorAll(".js-drawerButton");
  const header = document.getElementById("js-header");

  // ドロワーを開く
  const openDrawer = (button, drawerId) => {
    button.setAttribute("aria-expanded", "true");
    MicroModal.show(drawerId, {
      disableScroll: true,
      awaitOpenAnimation: true,
    });
    header.classList.add("is-open");
  };

  // ドロワーを閉じる
  const closeDrawer = (button, drawerId) => {
    button.setAttribute("aria-expanded", "false");
    MicroModal.close(drawerId, {
      awaitCloseAnimation: true,
    });
    header.classList.remove("is-open");
  };

  // モーダルが開いているとき、escキーを押したらモーダルを閉じる
  const escDrawerClose = (button, drawerId) => {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeDrawer(button, drawerId);
      }
    });
  };

  // モーダルが開いた状態で、モーダル内のページ内リンク(href="#"を含む)がクリックしたとき
  // モーダルを閉じる処理
  // さらに、ハンバーガーボタンのaria-expandedをfalseにする
  const drawerInPageLinkClose = (button, drawerId) => {
    const drawer = document.getElementById(drawerId);
    drawer.addEventListener("click", (e) => {
      if (e.target.href && e.target.href.includes("#")) {
        closeDrawer(button, drawerId);
      }
    });
  };

  // ボタンの処理
  buttons.forEach((button) => {
    const drawer = button.nextElementSibling;
    const drawerId = button.nextElementSibling.id;
    button.addEventListener("click", () => {
      const currentAriaExpanded = button.getAttribute("aria-expanded");

      if (currentAriaExpanded === "false") {
        openDrawer(button, drawerId);
      } else {
        closeDrawer(button, drawerId);
      }
    });

    // drawerの子要素でdata-micromodal-close 属性を持つ要素をクリックしたらモーダルを閉じる
    drawer.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-micromodal-close")) {
        closeDrawer(button, drawerId);
      }
    });

    escDrawerClose(button, drawerId);
    drawerInPageLinkClose(button, drawerId);
  });
}
